import { ReactNode, useId } from 'react';
import styled, { keyframes } from 'styled-components';

import { HexColor } from 'style/types';

const fader = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const rotator = keyframes`
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
`;

const Root = styled.div`
  --rotation-speed: 2s;
  display: grid;
  align-items: center;
  justify-items: center;
  width: 100%;
  height: 100%;
  > * {
    grid-row-start: 1;
    grid-column-start: 1;
  }
  svg {
    width: 100%;
    height: 100%;
  }
  g circle {
    animation:
      ${fader} var(--rotation-speed) ease forwards,
      ${rotator} var(--rotation-speed) ease-in-out forwards infinite;
    mix-blend-mode: screen;
    transform-origin: 50% 50%;
    &:nth-child(2n) {
      animation-duration: calc(var(--rotation-speed) * 2);
    }
    &:nth-child(3n) {
      animation-duration: calc(var(--rotation-speed) * 3);
    }
  }
`;

type Props = {
  children?: ReactNode;
  colors?: HexColor[];
};
export const RainbowCircle = ({
  children,
  colors = ['#FF0000', '#00FF00', '#0000FF'],
}: Props) => {
  const id = useId();
  return (
    <Root>
      <svg width="500" height="500" viewBox="0 0 500 500" fill="none">
        <defs>
          <mask id={id}>
            <circle cx="250" cy="250" r="220" fill="white" />
            <circle cx="250" cy="250" r="212" fill="black" />
          </mask>
        </defs>
        <g mask={`url(#${id})`}>
          {colors.map((color, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <circle key={index} cx="260" cy="245" r="210" fill={color} />
          ))}
        </g>
        <circle
          cx="260"
          cy="245"
          r="210"
          fill="var(--c-neutral-1000)"
          opacity="0.05"
        />
      </svg>
      <div>{children}</div>
    </Root>
  );
};
